import { Button,useMediaQuery, useTheme ,Theme  } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    returnButton: {
      width: 'fit-content',
      minWidth: 'unset',
      [theme.breakpoints.down('md')]: {
        padding: '0.5rem',
        marginBottom: '1.25rem',
        marginRight: '1rem',
      },
    },
  }),
);

function ReturnButton() {
  const navigate = useNavigate();
  const classes = useStyles(useTheme());
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Button
      color="secondary"
      variant="outlined"
      onClick={() => navigate(-1)}
      className={classes.returnButton}
    >
      {isMobile ? <>&#8592;</> : 'Volver'}
    </Button>
  );
}

export default ReturnButton;
